export default __webpack_public_path__ + "static/media/1.35c8cf93.jpg";